/* eslint-disable class-methods-use-this */
/* global logger */
const moment = require('moment');
const formating = require('./formating');
const Helper = require('./utils/helper');
const { MomentInitializer } = require('pando-holiday-lib');
const { orderType: OrderType, movementType } = require('pando-constants');


const IST_OFFSET = 3600000 * 5.5;
const MS_PER_HOUR = 3600000;

class LoadingDetention {
  getMomentDaysTimeOffset(momentVal) {
    return ((((momentVal.hour() * 60) + momentVal.minutes()) * 60) + momentVal.seconds()) * 1000;
  }

  calculateDetentionDays(detentionStartedAt, detentionEndedAt, start, end,
    depotCalenderMap, sourceLocatioId, loadingDetentionConfig = null) {
    const depotHolidays = depotCalenderMap ? depotCalenderMap[`${sourceLocatioId}`] : {};
    const momentBusinessDays = MomentInitializer.getHolidayAdjustedCalendar(depotHolidays);
    let _detentionStartedAt = moment(new Date(detentionStartedAt).getTime() + IST_OFFSET);
    let _detentionEndedAt = moment(new Date(detentionEndedAt).getTime() + IST_OFFSET);

    let difference;
    // if _detentionStartedAt is not bussiness day find next bussiness day
    if (!momentBusinessDays.isBusinessDay(_detentionStartedAt)) {
      const nextBusinessDay = momentBusinessDays.nextBusinessDay(_detentionStartedAt.clone()).startOf('day');
      if (moment(nextBusinessDay).isSameOrAfter(_detentionEndedAt, 'days')) {
        difference = 0;
        return difference;
      }
      _detentionStartedAt = nextBusinessDay;
    }
    let prevBusinessDayCheck = false;
    // if _detentionEndedAt is not bussiness day find previous bussiness day
    if (loadingDetentionConfig && !momentBusinessDays.isBusinessDay(_detentionEndedAt)) {
      const previousBusinessDay = momentBusinessDays.prevBusinessDay(_detentionEndedAt.clone()).endOf('day');
      if (moment(previousBusinessDay).isSameOrBefore(_detentionStartedAt, 'days')) {
        difference = 0;
        return difference;
      }
      prevBusinessDayCheck = true;
      _detentionEndedAt = previousBusinessDay;
    }
    let nonWorkingHours = 0;
    let started = moment(_detentionStartedAt).add(1, 'days').startOf('day');
    // non working hours between detentionStart and detentionEnd
    if (loadingDetentionConfig) {
      while (moment(started).isBefore(_detentionEndedAt)) {
        if (!momentBusinessDays.isBusinessDay(started)) {
          nonWorkingHours += 24;
        }
        started = moment(started).add(1, 'days');
      }
    }
    if (loadingDetentionConfig) {
      if (prevBusinessDayCheck) {
        _detentionEndedAt = moment(_detentionEndedAt).add(1, 'second');
      }
      difference = this.calculateDifferenceBasedOnDepotConfig(_detentionStartedAt,
        _detentionEndedAt);
      difference -= nonWorkingHours;
    } else {
      difference = this.calculateDifferenceBasedOnWindow(_detentionStartedAt,
        _detentionEndedAt, start, end);
    }
    return difference;
  }

  calculateDifferenceBasedOnDepotConfig(detentionStartAt, detentionEndAt) {
    const difference = detentionEndAt.diff(detentionStartAt, 'hours');
    if (difference < 0) {
      return 0;
    }
    return difference;
  }

  calculateDifferenceBasedOnWindow(detentionStartAt, detentionEndAt, start, end) {
    const detentionEndedDaysOffsetMillis = this.getMomentDaysTimeOffset(detentionEndAt);
    const detentionStartedDaysOffsetMillis = this.getMomentDaysTimeOffset(detentionStartAt);
    const difference = detentionEndAt.startOf('day').diff(detentionStartAt.startOf('day'), 'days');
    if (difference < 0) {
      return 0;
    }

    if (difference) {
      return (difference - 1) + (detentionStartedDaysOffsetMillis < start ? 1 : 0) +
        (detentionEndedDaysOffsetMillis > end ? 1 : 0);
    }
    // if detention started at before start window &
    //  ended at after end window configured in the client add 1
    return ((detentionStartedDaysOffsetMillis < start) &&
    (detentionEndedDaysOffsetMillis > end)) ? 1 : 0;
  }

  calculateDetentionCharges(charges, days) {
    let detentionCharge = 0;
    let detentionDays = days;
    for (let chargeIndex = 0; chargeIndex < charges.length && detentionDays > 0;
      detentionDays -= 1, chargeIndex += 1) {
      detentionCharge += charges[chargeIndex];
    }
    if (detentionDays > 0) {
      detentionCharge += charges[charges.length - 1] * (detentionDays);
    }
    return detentionCharge;
  }

  calculateLoadingDetentionBasedOnDepotConfiguration(data,
    depotCalenderMap, loadingDetentionConfig) {
    let sum = 0;
    const masterDepot = data.routeDetails && data.routeDetails.depot_id;
    data.sources.forEach((source) => {
      let currentDepotDetentionConfig;
      if (data.movement === movementType.INWARD || data.movement === movementType.RETURNS) {
        const destinationBySource = data.indentDestinations.find(
          destination => destination.sourceLocationId.toString()
           === source.locationId.toString());
        const depotId = masterDepot || destinationBySource.locationId;
        currentDepotDetentionConfig = loadingDetentionConfig.find(config =>
          depotId.toString() === config.depotId.toString());
      } else {
        const depotId = masterDepot || source.locationId;
        currentDepotDetentionConfig = loadingDetentionConfig.find(config =>
          depotId.toString() === config.depotId.toString());
      }
      if (currentDepotDetentionConfig) {
        const sourceLocatioId = source.locationId;
        const detention = data.sla.detention.actualDetentionWindowByDepot &&
          data.sla.detention.actualDetentionWindowByDepot[sourceLocatioId];
        const detentionStartedAt = moment(detention.startedAt, 'YYYY-MM-DD HH:mm:ss');
        const vehicleRequirementDate = moment(detention.vehicleRequirementDate, 'YYYY-MM-DD HH:mm:ss');
        const detentionEndedAt = moment(detention.endedAt, 'YYYY-MM-DD HH:mm:ss');
        if (!currentDepotDetentionConfig.include_holiday) {
          // eslint-disable-next-line no-param-reassign
          depotCalenderMap = null;
        }
        const sourceDepotId = masterDepot || source.locationId;
        let days = 0;
        if (currentDepotDetentionConfig && currentDepotDetentionConfig.operationBasedThresholdEnabled
          && currentDepotDetentionConfig.operationBasedThresholdEnabled === true) {
          days = this.calculateDetentionDays(detentionStartedAt,
            detentionEndedAt, currentDepotDetentionConfig.start_time, currentDepotDetentionConfig.end_time,
            depotCalenderMap, sourceDepotId);
          logger.info(`[loadingDetention]-${data.orderNo}-${sourceLocatioId} detention days - ${days}`);
        } else {
          const hours = this.calculateDetentionDays(detentionStartedAt > vehicleRequirementDate
            ? detentionStartedAt : vehicleRequirementDate, detentionEndedAt, null, null,
          depotCalenderMap, sourceDepotId, currentDepotDetentionConfig);
          logger.info(`[loadingDetention]-${data.orderNo}-${sourceLocatioId} detention hours - ${hours} , duration = ${currentDepotDetentionConfig.loadingDetention.duration}`);
          days = Math.floor(hours /
            (currentDepotDetentionConfig.loadingDetention.duration / MS_PER_HOUR));
          logger.info(`[loadingDetention]-${data.orderNo}-${sourceLocatioId} detention days - ${days}`);
        }
        sum += Number(days);
      } else {
        logger.error(`currentDepotDetentionConfig missing for source ${source.locationId.toString()}`);
      }
    });
    return sum;
  }

  /**
   * loading detention days would be the difference b/w truck in and truck out time
   */
  calculateLoadingDetentionBasedOnClientConfiguration(data, depotCalenderMap,
    loadingDetentionClientConfig) {
    let detentionDays = 0;
    const { startedAt: start, endedAt: end } = data.sla.detention.expectedDetentionWindowLoading;
    if (start && end) {
      detentionDays = data.sources.reduce((max, source) => {
        const sourceLocatioId = source.locationId;
        const detention = data.sla.detention.actualDetentionWindowByDepot &&
            data.sla.detention.actualDetentionWindowByDepot[sourceLocatioId];
        const detentionStartedAt = moment(detention.startedAt, 'YYYY-MM-DD HH:mm:ss');
        const vehicleRequirementDate = moment(detention.vehicleRequirementDate, 'YYYY-MM-DD HH:mm:ss');
        const detentionEndedAt = moment(detention.endedAt, 'YYYY-MM-DD HH:mm:ss');
        let detentionStart;
        if (loadingDetentionClientConfig
          && loadingDetentionClientConfig.start_from_truck_in) {
          detentionStart = detentionStartedAt;
        } else {
          detentionStart = (detentionStartedAt > vehicleRequirementDate)
            ? detentionStartedAt : vehicleRequirementDate;
        }

        if (loadingDetentionClientConfig && loadingDetentionClientConfig.exclude_holiday) {
          // eslint-disable-next-line no-param-reassign
          depotCalenderMap = null;
        }
        const masterDepot = data.routeDetails && data.routeDetails.depot_id;
        const sourceDepotId = masterDepot || source.locationId;
        const days = this.calculateDetentionDays(detentionStart, detentionEndedAt, start,
          end, depotCalenderMap, sourceDepotId);
        logger.info(`[loadingDetention]-${data && data.orderNo}-${sourceLocatioId} detention days - ${days}`);
        let _max = max;
        _max = Math.max(max, Number(days));
        return _max;
      }, 0);
    }
    return detentionDays;
  }

  calculateDetentionDaysWithLoadingDateCalc(data, depotCalenderMap) {
    const loadingDetentionConfig = data.loadingDetentionConfig;
    const loadingDetentionClientConfig = data.detentionClientConfig &&
      data.detentionClientConfig.loadingDetention;
    let days = 0;
    if (loadingDetentionConfig && loadingDetentionConfig.length) {
      logger.info(`[loadingDetention]-${data.orderNo} calculating loading delay in discrepancy by depot configuration`);
      days = this.calculateLoadingDetentionBasedOnDepotConfiguration(data, depotCalenderMap,
        loadingDetentionConfig);
    } else if (data.detentionBasedOnClient.loadingDetention) {
      logger.info(`[loadingDetention]-${data.orderNo} calculating loading delay in discrepancy by client configuration`);
      days = this.calculateLoadingDetentionBasedOnClientConfiguration(data, depotCalenderMap, loadingDetentionClientConfig);
    }
    return days;
  }

  calculateDetentionDaysWithLoadingDateCalcClientConfigBased(data, depotCalenderMap) {
    const loadingDetentionClientConfig = data.detentionClientConfig &&
      data.detentionClientConfig.loadingDetention;
    let days = 0;
    logger.info(`[loadingDetention]-${data.orderNo} calculating loading delay in discrepancy by client configuration`);
    days = this.calculateLoadingDetentionBasedOnClientConfiguration(data,
      depotCalenderMap, loadingDetentionClientConfig);
    return days;
  }

  calculateDetentionDelayWithLoadingDate(data, depotCalenderMap, depotConfiguration) {
    let loadingDetentionCharge = 0;
    try {
      if (data.orderType === OrderType.OPEN && !(depotConfiguration
        && depotConfiguration.open_indents_charge
        && depotConfiguration.open_indents_charge.loading_detention_charge)) {
        return 0;
      }
      const days = this.calculateDetentionDaysWithLoadingDateCalc(data, depotCalenderMap);
      if (days) {
        // Priority 1: Check indentSourceCharges for loading_detention
        let loadingDetentionMaster = null;
        const source = data.sources && data.sources[0];
        const sourceLocationId = source && source.locationId;
        const sourceGateId = source && source.gateId;
        
        if (sourceLocationId) {
          loadingDetentionMaster = Helper.getLoadingDetentionFromSourceCharges(data, sourceLocationId, sourceGateId);
        }
        
        // Priority 2: Fallback to detention master
        if (!loadingDetentionMaster) {
          const detentionCharge = Helper.getDetentionCharge(data);
          loadingDetentionMaster = (detentionCharge && detentionCharge.loading_detention) || [0];
        }
        
        const charge = this.calculateDetentionCharges(loadingDetentionMaster, days);
        loadingDetentionCharge += charge;
      }
    } catch (error) {
      logger.error(`Exception occurred while calculation loading detention ${error.stack}`);
    }
    return formating.formatWithPaymentField(Number(loadingDetentionCharge).toFixed(2));
  }

  calculateDetentionDelayWithLoadingDateClientConfigBased(data,
    depotCalenderMap, depotConfiguration) {
    let loadingDetentionCharge = 0;
    try {
      if (data.orderType === OrderType.OPEN && !(depotConfiguration
        && depotConfiguration.open_indents_charge
        && depotConfiguration.open_indents_charge.loading_detention_charge)) {
        return 0;
      }
      const days = this.calculateDetentionDaysWithLoadingDateCalcClientConfigBased(data,
        depotCalenderMap);
      if (days) {
        // Priority 1: Check indentSourceCharges for loading_detention
        let loadingDetentionMaster = null;
        const source = data.sources && data.sources[0];
        const sourceLocationId = source && source.locationId;
        const sourceGateId = source && source.gateId;
        
        if (sourceLocationId) {
          loadingDetentionMaster = Helper.getLoadingDetentionFromSourceCharges(data, sourceLocationId, sourceGateId);
        }
        
        // Priority 2: Fallback to detention master
        if (!loadingDetentionMaster) {
          const detentionCharge = Helper.getDetentionCharge(data);
          loadingDetentionMaster = (detentionCharge && detentionCharge.loading_detention) || [0];
        }
        
        const charge = this.calculateDetentionCharges(loadingDetentionMaster, days);
        loadingDetentionCharge += charge;
      }
    } catch (error) {
      logger.error(`Exception occurred while calculation loading detention ${error.stack}`);
    }
    return formating.formatWithPaymentField(Number(loadingDetentionCharge).toFixed(2));
  }

  calculateDetentionDaysWithLoadingDate(data, depotCalenderMap, depotConfiguration) {
    let days = 0;
    try {
      if (data.orderType === OrderType.OPEN && !(depotConfiguration
        && depotConfiguration.open_indents_charge
        && depotConfiguration.open_indents_charge.loading_detention_charge)) {
        return 0;
      }
      days = this.calculateDetentionDaysWithLoadingDateCalc(data, depotCalenderMap);
      return days;
    } catch (error) {
      logger.error(`Exception occurred while calculation loading detention ${error.stack}`);
    }
    return days;
  }

  calculateDetentionDaysWithLoadingDateClientConfigBased(data,
    depotCalenderMap, depotConfiguration) {
    let days = 0;
    try {
      if (data.orderType === OrderType.OPEN && !(depotConfiguration
        && depotConfiguration.open_indents_charge
        && depotConfiguration.open_indents_charge.loading_detention_charge)) {
        return 0;
      }
      days = this.calculateDetentionDaysWithLoadingDateCalcClientConfigBased(data,
        depotCalenderMap);
      return days;
    } catch (error) {
      logger.error(`Exception occurred while calculation loading detention ${error.stack}`);
    }
    return days;
  }
}

module.exports = LoadingDetention;
